import { render, staticRenderFns } from "./ExtentionCard.vue?vue&type=template&id=6d4ef816&scoped=true"
import script from "./ExtentionCard.vue?vue&type=script&lang=js"
export * from "./ExtentionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ef816",
  null
  
)

export default component.exports